export const USER_KIND_USER = "User";
export const USER_KIND_DART_AI = "Dart AI";
export const USER_KIND_CUSTOM = "Custom";

export const DART_AI_NAME = USER_KIND_DART_AI;

export const AGENT_USER_KINDS = [USER_KIND_DART_AI, USER_KIND_CUSTOM];
